// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__33G0z","errors":"Errors_errors__3Hg-t"};